import { render, staticRenderFns } from "./PhotoFrame.vue?vue&type=template&id=7ef8a14f&"
import script from "./PhotoFrame.vue?vue&type=script&lang=js&"
export * from "./PhotoFrame.vue?vue&type=script&lang=js&"
import style0 from "./PhotoFrame.vue?vue&type=style&index=0&id=7ef8a14f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports